import { Injectable } from "@angular/core";
import { DialogLike, DialogService } from "@obg/mat.ui.core";
import { map } from "rxjs/operators";

import { LATEST_PRIVACY_POLICY_DIALOG_ID } from "./latest-privacy-policy.const";
import { LatestPrivacyPolicyContainer } from "./latest-privacy-policy.container";

const LATEST_PRIVACY_POLICY_DIALOG: DialogLike<LatestPrivacyPolicyContainer> = {
	dialogId: LATEST_PRIVACY_POLICY_DIALOG_ID,
	dialogComponentType: LatestPrivacyPolicyContainer,
	onClose$: (c) => c.close,
	onBusy$: (c) => c.busy.pipe(map((isBusy) => ({ isBusy }))),
};

@Injectable({
	providedIn: "root",
})
export class LatestPrivacyPolicyDialogService {
	constructor(private readonly dialogService: DialogService) {}

	open() {
		return () => {
			this.dialogService.openComponent(LATEST_PRIVACY_POLICY_DIALOG, {
				disableClose: true,
				panelClass: "latest-privacy-policy-dialog",
				data: {
					hideClose: true,
					hideFooter: true,
				},
				autoFocus: false,
			});
		};
	}
}
